const CloseIcon: React.FC<{ fill?: string; className?: string }> = ({
  fill,
  className,
}) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.88629 7.5L14.5058 2.88051C15.1647 2.22155 15.1647 1.15318 14.5058 0.494222C13.8468 -0.164741 12.7785 -0.164741 12.1195 0.494222L7.5 5.11371L2.88051 0.494222C2.22155 -0.164741 1.15318 -0.164741 0.494222 0.494222C-0.164741 1.15318 -0.164741 2.22155 0.494222 2.88051L5.11371 7.5L0.494222 12.1195C-0.164741 12.7784 -0.164741 13.8468 0.494222 14.5058C0.823703 14.8352 1.25553 15 1.68735 15C2.11918 15 2.55103 14.8353 2.88048 14.5058L7.5 9.88629L12.1195 14.5058C12.449 14.8352 12.8808 15 13.3126 15C13.7444 15 14.1763 14.8353 14.5057 14.5058C15.1647 13.8468 15.1647 12.7784 14.5057 12.1195L9.88629 7.5Z"
        fill={fill || "#2A3447"}
      />
    </svg>
  );
};

export default CloseIcon;
